export default "/_next/static/chunks/fonts/Rubik-Light-8e4b01844ace913e46fc5023f57a2cfc.ttf";